import { render } from "./HeroiconsOutlineDuplicate.vue?vue&type=template&id=340d4d26"
const script = {}

import exportComponent from "/Users/larkinwhitaker/Projects/eye-rep/modules/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDuplicate.vue"]])

export default __exports__